import _ from 'lodash'
import { cn } from '@/lib/utils'
import { CurrencyGridItem } from '@/components/profile/currency/CurrencyGridItem'
import type { Currency } from '@/types/payment'

interface CurrencyGridProps {
	currencies: Currency[]
	selectedCodes: string[]
	onCurrencyCheckedChange: (currencyCode: string, checked: boolean) => void
	isLoading?: boolean
	className?: string
}

export function CurrencyGrid({ currencies, selectedCodes, onCurrencyCheckedChange, isLoading, className }: CurrencyGridProps) {
	if (isLoading) {
		return (
			<div className={cn('grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4', className)}>
				{_.times(8, (index) => (
					<div key={index} className='h-[52px] animate-pulse rounded-xl border border-border bg-secondary' />
				))}
			</div>
		)
	}

	if (_.isEmpty(currencies)) {
		return <p className={cn('py-6 text-center text-sm text-muted-foreground', className)}>No additional currencies available.</p>
	}

	const selectedCodeSet = new Set(_.map(selectedCodes, (code) => code.toUpperCase()))

	return (
		<div className={cn('grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4', className)}>
			{_.map(currencies, (currency) => (
				<CurrencyGridItem
					key={currency.id}
					currency={currency}
					isSelected={selectedCodeSet.has(currency.currency_code.toUpperCase())}
					onCheckedChange={(checked) => onCurrencyCheckedChange(currency.currency_code, checked)}
				/>
			))}
		</div>
	)
}
